import type { MRT_Localization } from 'material-react-table';

export const Localization_RU: MRT_Localization = {
	actions: 'Действия',
	and: 'и',
	cancel: 'Отменить',
	changeFilterMode: 'Изменить режим фильтра',
	changeSearchMode: 'Изменить режим поиска',
	clearFilter: 'Очистить фильтр',
	clearSearch: 'Очистить поиск',
	//clearSelection: 'Очистить выбор',
	clearSelection: '',
	clearSort: 'Очистить сортировку',
	clickToCopy: 'Нажмите, чтобы скопировать',
	copy: 'Копировать',
	columnActions: 'Действие колонки',
	copiedToClipboard: 'Скопировано в буфер обмена',
	collapse: 'Свернуть',
	collapseAll: 'Свернуть все',
	dropToGroupBy: 'Добавить в группу к {column}',
	edit: 'Редактировать',
	expand: 'Раскрыть',
	expandAll: 'Раскрыть все',
	filterArrIncludes: 'Включить',
	filterArrIncludesAll: 'Влючить все',
	filterArrIncludesSome: 'Включить',
	filterBetween: 'Между',
	filterBetweenInclusive: 'Между включительно',
	filterByColumn: 'Отфильтровать по {column}',
	filterContains: 'Содержит',
	filterEmpty: 'Пустой',
	filterEndsWith: 'Оканчивается',
	filterEquals: 'Равны',
	filterEqualsString: 'Равны',
	filterFuzzy: 'Физзи',
	filterGreaterThan: 'Больше чем',
	filterGreaterThanOrEqualTo: 'Больше или равно',
	filterInNumberRange: 'Между',
	filterIncludesString: 'Содержит',
	filterIncludesStringSensitive: 'Содержит (регистрозависимый)',
	filterLessThan: 'Меньше чем',
	filterLessThanOrEqualTo: 'Меньше или равно',
	filterMode: 'Режим фильтра: {filterType}',
	filterNotEmpty: 'Не пустое',
	filterNotEquals: 'Не равны',
	filterStartsWith: 'Начинается с',
	filterWeakEquals: 'Равны',
	filteringByColumn: 'Фильтр по {column} - {filterType} {filterValue}',
	goToFirstPage: 'Перейти на первую страницу',
	goToLastPage: 'Перейти на последнюю страницу',
	goToNextPage: 'Перейти на следующую страницу',
	goToPreviousPage: 'Перейти на предыдущую страницу',
	grab: 'Grab',
	groupByColumn: 'Сгруппировать по {column}',
	groupedBy: 'Сгруппировать',
	hideAll: 'Скрыть всё',
	hideColumn: 'Скрыть {column} колонку',
	max: 'Макс',
	min: 'Мин',
	move: 'Двигать',
	noRecordsToDisplay: 'Нет записей для показа',
	noResultsFound: 'Результатов не найдено',
	of: 'из',
	or: 'или',
	pin: 'Прикрепить',
	pinToLeft: 'Прикрепить слева',
	pinToRight: 'Прикрепить справа',
	resetColumnSize: 'Сбросить размер колонок',
	resetOrder: 'Сбросить порядок',
	rowActions: 'Действия строки',
	rowNumber: '#',
	rowNumbers: 'Количество строк',
	//rowsPerPage: 'Строк на странице',
	rowsPerPage: '',
	save: 'Сохранить',
	search: 'Найти',
	//selectedCountOfRowCountRowsSelected: '{selectedCount} из {rowCount} строк выбрано',
	selectedCountOfRowCountRowsSelected: 'Бланков: {selectedCount}',
	select: 'Выбрать',
	showAll: 'Показать все',
	showAllColumns: 'Показать все колонки',
	showHideColumns: 'Показать/скрыть колонки',
	showHideFilters: 'Показать/скрыть фильтры',
	showHideSearch: 'Показать/скрыть поиск',
	sortByColumnAsc: 'Сортировать {column} по возрастанию',
	sortByColumnDesc: 'Сортировать {column} по убыванию',
	sortedByColumnAsc: 'Отсортирована по {column} возрастанию',
	sortedByColumnDesc: 'Отсортирована по {column} убыванию',
	thenBy: ', затем ',
	toggleDensity: 'Изменить плотность',
	toggleFullScreen: 'Включить полноэкранный режим',
	toggleSelectAll: 'Выбрать всё',
	toggleSelectRow: 'Переключить выбор строки',
	toggleVisibility: 'Изменить видимость',
	ungroupByColumn: 'Разгруппировать по {column}',
	unpin: 'Открепить',
	unpinAll: 'Открепить всё',
};
